import type { EPortal } from '@/frontend/src/types/portal';
import { isFrenchPortal } from '@/frontend/src/helpers/portal';

export enum EPostalCodeValidationError {
    None = 'none',
    DromTomNotSupported = 'dromTomNotSupported',
    Invalid = 'invalid',
}

/*
 * Helper function to validate postal codes for French portals
 * Metropolitan France postal codes range from 01000 to 95999
 * DROM codes: 97xxx (971-976)
 * COM/TOM codes: 98xxx
 */
export const validatePostalCode = (
    postalCode: string | undefined,
    portal: EPortal,
): EPostalCodeValidationError => {
    // Only validate for French portals
    if (!isFrenchPortal(portal)) {
        return EPostalCodeValidationError.None;
    }

    // Empty or undefined is handled by required field validation
    if (!postalCode) {
        return EPostalCodeValidationError.None;
    }

    // Check if it's a valid metropolitan postal code
    if (/^(0[1-9]|[1-8]\d|9[0-5])\d{3}$/.test(postalCode)) {
        return EPostalCodeValidationError.None;
    }

    // Check if it's a DROM (97xxx) or COM/TOM (98xxx) postal code
    if (/^9[78]\d{3}$/.test(postalCode)) {
        return EPostalCodeValidationError.DromTomNotSupported;
    }

    // Otherwise, it's an invalid format
    return EPostalCodeValidationError.Invalid;
};
